module.exports = __webpack_public_path__ + "img/1.a359e46f.jpg";